import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled, {  } from 'styled-components'
import Counter from 'components/counter'
import AnimationContainer from 'components/animation-container'


class Cifras extends React.Component {


    shouldComponentUpdate() {
        return false
    }
      
    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #050505;
            padding-top: 50px;
            .particles {
                position: absolute;
                width: 100%;
                height: 100%;
            }
            @media (max-width: 767px) {
                padding: 80px 20px;
            }
            @media (max-width: 500px) {
                padding: 0 20px;
            }
        `

        const CounterRow = styled(Row)`
            margin-top: 5px;
            background-color: #000;
            padding: 100px 0;
            @media (max-width: 500px) {
                margin-top: 0;
            }

        `
                
        const CounterComponent = styled.div`
            margin: 10px 0;
            text-align: center;
            @media (max-width:767px) {
                margin: 50px 0;
                text-align:center;
            }
            .value {
                font-size: 100px;
                font-family: Teko;
                color: #fff;
                line-height: 90px;
                margin-left: 30px;
            }
            .text {
                font-size: 20px;
                color: #fff;
            }
            .symbol {
                color: #04e5e5;
                position: absolute;
                font-size: 39px;                
                @media (max-width: 500px) {
                    
                }
            }

        `        

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 20px;
        `

        const Heading = styled.h4`
            font-size: 70px;
            line-height: 80px;
            Font-family: Poppins;           
            color: #fff;            
            margin-top: 80px;
        `

        return(
            <Section id="cifras">
                <CounterRow>
                    <Container>
                        <Row>
                            <Col md={3}>
                                <AnimationContainer animation="fadeIn" delay={1000}>
                                    <CounterComponent>
                                        <Counter symbol="+" value={14} duration={5} delay={1000} text="Años de experiencia" animation={true} />
                                    </CounterComponent>
                                </AnimationContainer>
                            </Col>
                            <Col md={3}>
                                <AnimationContainer animation="fadeIn" delay={1000}>
                                    <CounterComponent>
                                        <Counter value={4} duration={5} delay={1000} symbol="+" text="Países con clientes atendidos" animation={true} />
                                    </CounterComponent>
                                </AnimationContainer>
                            </Col>
                            <Col md={3}>
                                <AnimationContainer animation="fadeIn" delay={1000}>
                                    <CounterComponent>
                                        <Counter value={100} duration={5} delay={1000} symbol2="%" text="Entregas de la mejor calidad" animation={true} />
                                    </CounterComponent>
                                </AnimationContainer>
                            </Col>
                            <Col md={3}>
                                <AnimationContainer animation="fadeIn" delay={1000}>
                                    <CounterComponent>
                                        <Counter value={73900} duration={5} delay={1000} symbol="+" text="Horas de investigación" animation={true} />
                                    </CounterComponent>
                                </AnimationContainer>
                            </Col>
                            <Col md={12}>
                                <AnimationContainer animation="fadeIn" delay={1000}>
                                    <Heading>Y mucho café...</Heading>
                                    <Separator />
                                </AnimationContainer>
                            </Col>
                        </Row>
                    </Container>
                </CounterRow>
            </Section>
        )
    }
}

export default Cifras;
